import { render, staticRenderFns } from "./SellerLogo.vue?vue&type=template&id=06db1636&scoped=true&"
import script from "./SellerLogo.vue?vue&type=script&lang=js&"
export * from "./SellerLogo.vue?vue&type=script&lang=js&"
import style0 from "./SellerLogo.vue?vue&type=style&index=0&id=06db1636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db1636",
  null
  
)

export default component.exports